import React, { useEffect, useCallback } from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import PortfolioBuilderStore from '../stores';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { ConfirmationGrid } from './GridComponents';
import { AD_BUDGET_TYPE } from 'sl-ad-campaign-manager-data-model';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { createPortfolio } from '../utils';
import color from 'src/utils/colors';
import { useSnackbar } from 'src/utils/Hooks';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import { getQueryParamValue } from 'src/utils/app';
import { hexToRgba } from '@stackline/ui';

const PortfolioConfirmation = () => {
  const { portfolioName, budget, selectedEntityId, selectedOptimizationId, selectedCampaignIds } =
    PortfolioBuilderStore((s) => ({
      portfolioName: s.portfolioName,
      budget: s.budget,
      selectedEntityId: s.selectedEntityId,
      selectedOptimizationId: s.selectedOptimizationId,
      selectedCampaignIds: s.selectedCampaignIds
    }));
  const { beaconNavigator } = useBeaconNavigator();

  const payload = {
    name: portfolioName,
    entity: {
      id: selectedEntityId
    },
    strategy: {
      id: selectedOptimizationId
    },
    budgetType: {
      name: AD_BUDGET_TYPE.MONTHLY_RECURRING
    },
    budgetAmount: budget,
    campaignIds: Array.from(selectedCampaignIds) as string[]
  };
  const retailerId = getQueryParamValue('rid');

  useEffect(() => {
    if (!portfolioName) {
      beaconNavigator.updateSearchParams({ tab: 'advertising', subtab: 'adMetrics', rid: retailerId });
      beaconNavigator.go();
    }
  }, [beaconNavigator, portfolioName, retailerId]);

  const { showSnackbar } = useSnackbar();

  const handleSubmit = useCallback(async () => {
    try {
      await createPortfolio(payload);
      showSnackbar({
        message: 'Your portfolio was successfully created.',
        type: 'success'
      });

      beaconNavigator.updateSearchParams({ tab: 'advertising', subtab: 'adMetrics', rid: retailerId });
      beaconNavigator.go();
    } catch (e) {
      console.error('Error submitting data', e);
      showSnackbar({
        message: 'An error occurred. Please reach out to support@stackline.com for further guidance.',
        type: 'error'
      });
    }
  }, [retailerId, beaconNavigator, payload, showSnackbar]);

  return (
    <BasePageContainer>
      <Flex gap={32} flexDirection="column">
        <Text
          variant="h3"
          sx={{
            '&::after': {
              content: '""',
              display: 'block',
              width: '100%',
              height: '1px',
              backgroundColor: hexToRgba(color.darkBlue, 0.12),
              marginTop: '12px'
            }
          }}
        >
          Details
        </Text>
        <ConfirmationGrid />
        <Flex
          justifyContent="space-between"
          sx={{
            marginTop: '64px'
          }}
        >
          <SlButton
            buttonSx={{
              backgroundColor: color.graysPrimary,
              border: `1px solid ${color.graysSecondary}`
            }}
            onClick={() => {
              window.history.back();
            }}
          >
            Back
          </SlButton>
          <SlButton variant="contained" onClick={handleSubmit}>
            Save
          </SlButton>
        </Flex>
      </Flex>
    </BasePageContainer>
  );
};

export default PortfolioConfirmation;
